import React from 'react';
import './CriticalCustom_Orion.css'
import DashboardMain_Orion from '../DashboardMain_Orion/DashboardMain_Orion';
import * as $ from 'jquery';
import { useCallback, useContext, useEffect, useState } from "react";
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_bus';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../hook/use-http'
import CriticalTables_Orion from './CriticalTables_Orion';
import Critical_Filters_Orion from './Critical_Filters_Orion';
import { decodeToken } from 'react-jwt';
import CriticalTablesWithDropwon_Orion from './CriticalTablesWithDropwon_Orion';
import CriticalMonthGraph_Orion from './CriticalMonthGraph_Orion';
import CriticalBattery_Orion from './CriticalBattery_Orion';
import CriticalTableSection_Orion from './CriticalTableSection_Orion';

export default function Critical_vehicles_Orion() {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE

  const [gloablfilter, setGloablfilter] = useState(sampleObj)
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const log_data = () => ""

  useEffect(() => {
    // window.$("#button-1_Bus").checked = false
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "Critical_Vehicles_Orion"
      }
    }, log_data)
  }, []);

  const [fromTableToFilter_vin, setFromTableToFilter_vin] = useState(0);
  const filterSubmited = useCallback((data) => {
    if (data.VIN_NUM.length === 1) {
      setFromTableToFilter_vin(data.VIN_NUM[0])
    }
    setGloablfilter(data);
  }, []);

  const onreset = (data) => {
    setGloablfilter(data);
  }

  const arr = [
    { title: "Lowest SOH vehicles", apiEndPoint: "lowest_SOC_SOH_vehicles", packType: "A", withDropdown: "_SOH" },
    { title: "Highest Current Imbalance", apiEndPoint: "highest_SOC_current_imbalance", packType: "total_duration", withDropdown: "_Duration" },
    { title: "Highest Temp vehicles (Pack A)", apiEndPoint: "highest_Temp_vehicles", packType: "A", withDropdown: "_Temp" },
    { title: "Highest Temp vehicles (Pack B)", apiEndPoint: "highest_Temp_vehicles", packType: "B", withDropdown: "_Temp", rightZero: false },
    { title: "Lowest SOC vehicles", apiEndPoint: "lowest_SOC_SOH_vehicles", packType: "A", withDropdown: "_SOC" },
    { title: "Highest SOC Imbalance", apiEndPoint: "highest_SOC_current_imbalance", packType: "total_soc_duration", withDropdown: "_Duration" },
    { title: "Highest Temp vehicles (Pack C)", apiEndPoint: "highest_Temp_vehicles", packType: "C", withDropdown: "_Temp" },
    { title: "Highest Temp vehicles (Pack D)", apiEndPoint: "highest_Temp_vehicles", packType: "D", withDropdown: "_Temp", rightZero: false },
  ]

  const [maxPackIndex, setMaxPackIndex] =useState([]);
  const resetfunc = (maxIndexA, maxIndexB, maxIndexC, maxIndexD) => {
    const maxIndices = [maxIndexA, maxIndexB, maxIndexC, maxIndexD];
    setMaxPackIndex(maxIndices)
  }

  return (
    <>
      <DashboardMain_Orion>
        <div className='main_hole_background'>
          <Critical_Filters_Orion onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} fromTableToFilter_vin={fromTableToFilter_vin} />
          <div className="container-fluid pb-1">
            <section className="highlights">

              <div className="row mb-2 equal-cols">
                {
                  arr.map((item, index) => {
                    let key = `item_${index}`;
                    if (index === 0 || index === 4) {
                      return (<CriticalTablesWithDropwon_Orion key={key} gloablfilter={gloablfilter} extraThings={item} />)
                    } else {
                      return (<CriticalTables_Orion key={key} gloablfilter={gloablfilter} extraThings={item} />)
                    }
                  })
                }
              </div>

              <div className="row mb-2 mt-3 equal-cols">
                <div className='col-md-4 pr-1' >
                  <CriticalMonthGraph_Orion gloablfilter={gloablfilter}/>
                </div>
                <div className='col-md-5 '>
                  <CriticalBattery_Orion gloablfilter={gloablfilter} onreset={resetfunc}/>
                  {/* <CriticalPackWiseTable gloablfilter={gloablfilter}/> */}
                </div>
                <div className='col-md-3 pl-1'>
                  <CriticalTableSection_Orion gloablfilter={gloablfilter} maxPackIndex={maxPackIndex}/>
                  {/* <CriticalPackWiseTable gloablfilter={gloablfilter}/> */}
                </div>
              </div>
              
            </section>
          </div>
        </div>
      </DashboardMain_Orion>
    </>
  )
}